<template>
  <picture>
    <slot></slot>
  </picture>
</template>

<script>
export default {
  props: {
    // is used by CloudImage only
    fixed: {
      type: Boolean,
      required: false,
    },
    // is used by CloudImage only
    singleSrc: {
      type: Boolean,
      required: false,
    },
    // is used by CloudImage only
    lazy: {
      type: Boolean,
      required: false,
    },
    width: {
      type: Number,
      required: false,
      default: undefined,
    },
    alt: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
</script>
